import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CreateEditCatalogComponent } from './pages/create-edit-catalog/create-edit-catalog.component';
import { ListCatalogsComponent } from './pages/list-catalogs/list-catalogs.component';

const firstBreadcrumb = {
  title: 'Con-Héctor',
  icon: '../../../assets/img/ConHector/Personaje_acciones/icon.png',
  url: '/',
};

const routes: Routes = [
  {
    path: 'list',
    component: ListCatalogsComponent,
    data: {
      firstBreadcrumb,
      title: 'Catálogos',
      url: 'catalogs/list',
    },
  },
  {
    path: 'create',
    component: CreateEditCatalogComponent,
    data: {
      firstBreadcrumb,
      title: 'Nuevo catálogo',
      url: 'catalogs/create',
    },
  },
  {
    path: 'edit/:id',
    component: CreateEditCatalogComponent,
    data: {
      firstBreadcrumb,
      title: 'Editar catálogo',
      url: 'catalogs/edit',
    },
  },
  { path: '', redirectTo: 'list', pathMatch: 'full' },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class CatalogsRoutingModule {}
